<app-card
  class="card-container"
  [class.disabled]="!blog.entitled"
>
  <div class="card-tagline">
    <em class="icon-locked" *ngIf="!blog.entitled"></em>
    <span class="truncate-ellipsis">{{ blog.subscriptionName }}</span>
  </div>
  <div
    class="card-title truncate-paragraph-ellipsis line-clamp-2"
    [class.fixed-height]="consistentHeight"
    [innerHTML]="blog.name"
  ></div>
  <div
    class="card-description truncate-paragraph-ellipsis line-clamp-3"
    [class.fixed-height]="consistentHeight"
    [innerHTML]="blog.description"
  ></div>
  <div class="card-footer">
    <span class="publication-date">{{ blog.completionDate| date: 'MMM d, yyyy' }}</span>
    <div class="footer-content">
      <em
        class="author-avatar"
        [class.icon-profile]="!blog.authorAvatar"
        [style.background-image]="blog.authorAvatar ? 'url(' + blog.authorAvatar + ')' : 'none'"
      ></em>
      {{ blog.author }}
    </div>
  </div>
</app-card>
